import { PhoneNumberUtil } from "google-libphonenumber";
import HWLog from "./HWLog";

// Checks if an object is undefined or empty. A string is empty if it has only whitespaces.
export const isEmpty = (object) => {
  return (
    object === undefined ||
    object === null ||
    (typeof object === "string" && object.trim() === "") ||
    (Array.isArray(object) && object.length === 0)
  );
};

export const isAnyEmpty = (...objects) => {
  for (let object of objects) {
    if (isEmpty(object)) {
      return true;
    }
  }
  return false;
};

export const areAllEmpty = (...objects) => {
  for (let object of objects) {
    if (!isEmpty(object)) {
      return false;
    }
  }
  return true;
};

export const validateEmail = (emailId) => {
  if (!emailId) return false;
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(emailId)
    ? true
    : false;
};

export const isValidPhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return false;
  try {
    let phoneNumberString =
      phoneNumber.indexOf("+") === -1 ? "+" + phoneNumber : phoneNumber;
    let phoneNumberUtil = PhoneNumberUtil.getInstance();
    let number = phoneNumberUtil.parse(phoneNumberString);
    return phoneNumberUtil.isValidNumber(number);
  } catch (error) {
    console.log(error);
    return false;
  }
};

export const getUserLocation = () => {
  return Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject("No Location Access:");
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (onSuccessResult) => {
        resolve(onSuccessResult);
        HWLog.info("SUCCESS LOCATION");
      },
      (onErrorResult) => {
        reject(onErrorResult);
        HWLog.info("ERROR LOCATION");
      }
    );
  });
};

export const dateByAdding = (numberOfDays) => {
  let date = new Date();
  date.setDate(date.getDate() + numberOfDays);
  return date;
};
